// extracted by mini-css-extract-plugin
export default {"headerBar":"_K-z","pointsSection":"aL-z","goToDashboard":"bL-z"};